//@ts-strict-ignore
import { allOptions } from '../components/MenuOptions/useMenuOptions';
import { cloneDeep } from '@apollo/client/utilities';

export function createMenuForStore(userActions, isAdmin) {
  const optionsCopy = cloneDeep(allOptions);
  const userActionsCopy = cloneDeep(userActions);
  return filterMenuOnPermissions(optionsCopy, userActionsCopy, isAdmin);
}

const getActionMap = (userActions) => {
  const tempObj = {};
  for (const action of userActions) {
    tempObj[action.action.name] = {
      permitted: action.permitted,
      children: action.action.children,
    };
  }
  return tempObj;
};

const filterSubMenuOnPermissions = (menu, actionMap) => {
  let enableSubMenu = false;

  Object.keys(menu).forEach((menuItem) => {
    let enableOuterMenu = false;

    if (!Array.isArray(menu[menuItem])) return;

    for (let j = menu[menuItem].length - 1; j >= 0; j--) {
      const section = menu[menuItem][j];
      if (section.screenReference) {
        if (childrenHavePermission(section, actionMap)) {
          enableOuterMenu = true;
        } else {
          menu[menuItem].splice(j, 1);
        }
      } else {
        const subMenuScan = filterSubMenuOnPermissions(section, actionMap);
        menu[menuItem][j] = subMenuScan.menu;
        if (subMenuScan.permitted) {
          enableOuterMenu = true;
        } else {
          menu[menuItem].splice(j, 1);
        }
      }
    }
    if (enableOuterMenu) {
      enableSubMenu = true;
    } else {
      delete menu[menuItem];
    }
  });

  return {
    menu: menu,
    permitted: enableSubMenu,
  };
};

const filterMenuOnPermissions = (menu, userActions, isAdmin) => {
  if (isAdmin) {
    return menu;
  } else if (userActions) {
    const { permitted, menu: subMenu } = filterSubMenuOnPermissions(menu, getActionMap(userActions));
    return permitted ? subMenu : [];
  }
};

export const filterMenuOnPermissionsModalsSystem = (menu, userActions, isAdmin) => {
  const menuCopy = cloneDeep(menu);
  const userActionsCopy = cloneDeep(userActions);

  if (isAdmin) {
    return menuCopy;
  } else if (userActionsCopy) {
    const actionMap = getActionMap(userActionsCopy);
    for (let i = menuCopy.length - 1; i >= 0; i--) {
      let keepMenuItem = false;
      const menuItem = menuCopy[i];
      if (actionMap[menuItem.screenReference] && actionMap[menuItem.screenReference].permitted) {
        keepMenuItem = true;
      }
      if (!keepMenuItem) {
        keepMenuItem = childrenHavePermission(menuItem, actionMap);
        if (!keepMenuItem) {
          menuCopy.splice(i, 1);
        }
      }
    }
  }
  return menuCopy;
};

const checkAction = (actionMap, actionKey) => {
  if (!actionMap[actionKey]) {
    return false;
  } else if (actionMap[actionKey].permitted) {
    //Permitted - Should already be a screen leaf so trickle up with true.
    return true;
  }

  return false;
};

const childrenHavePermission = (section, actionMap, permissionName = 'screenReference') => {
  if (Array.isArray(section[permissionName])) {
    return section[permissionName].every((permission) =>
      checkAction(
        actionMap,
        Object.keys(actionMap).find((value) => value === permission)
      )
    );
  }
  return checkAction(
    actionMap,
    Object.keys(actionMap).find((value) => value === section[permissionName])
  );
};

const checkChildren = (children, actionMap) => {
  for (const child of children) {
    if (actionMap[child.name]) {
      if (actionMap[child.name].permitted) {
        return true;
      }
      if (actionMap[child.name].children.length > 0) {
        if (checkChildren(actionMap[child.name].children, actionMap)) {
          return true;
        }
      }
    }
  }
  return false;
};
